<template>
    <iframe src="https://jp-prototypes-v4.pages.dev/html/dashboard/integrations" class="container-height" width="100%" style="border: 0;padding: 0;margin: 0">
    </iframe>
</template>

<script>
  export default {
    name: 'Integrations',
    metaInfo: {
      title: 'Integrations',
    },
  };
</script>

